export const TOKEN_TIME_BEFORE_EXPIRATION = 300000; // 5 min

// db limits
export const DB_MAX_TEXT_LENGTH = 255;
export const DB_MAX_TEXT_LENGTH_SHORT = 64;

// Inactivity
export const INACTIVITY_TIMEOUT = 60 * 60 * 1000; // 1 hour in milliseconds
